import { render } from "./tutorsProfile.vue?vue&type=template&id=22800eca&scoped=true"
import script from "./tutorsProfile.vue?vue&type=script&lang=js"
export * from "./tutorsProfile.vue?vue&type=script&lang=js"

import "./tutorsProfile.vue?vue&type=style&index=0&id=22800eca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22800eca"]])

export default __exports__